import script from "./MyBenefit.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBenefit.vue?vue&type=script&setup=true&lang=js"

import "./MyBenefit.vue?vue&type=style&index=0&id=3a8ae1c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a8ae1c4"]])

export default __exports__